module.exports = __webpack_public_path__ + "img/svgBg.4d20dd56.png";